import { NavLink } from "react-router-dom";

export default function Footer() {
  const navLinkClass = ({ isActive }) =>
    `text-decoration-none ${isActive ? "text-primary" : "text-muted"}`;

  return (
    <footer className="bg-white border-top p-2 pb-4 fixed-bottom text-center">
      <div className="row g-0 fs-5 align-items-center">
        <div className="col">
          <NavLink to="/for-you" className={navLinkClass}>
            <i className="fi fi-rr-rocket-lunch"></i>
          </NavLink>
        </div>

        <div className="col">
          <NavLink to="/social-media" className={navLinkClass}>
            <i className="fi fi-rr-calendar-day"></i>
          </NavLink>
        </div>

        <div className="col">
          <NavLink to="/my-drafts" className={navLinkClass}>
            <i className="fi fi-rr-edit"></i>
          </NavLink>
        </div>

        <div className="col">
          <button
            type="button"
            className="btn btn-primary rounded-circle"
            data-bs-toggle="modal"
            data-bs-target="#draft-prompt"
          >
            <i className="fi fi-rr-plus"></i>
          </button>
        </div>

        <div className="col">
          <button
            type="button"
            className="text-muted text-decoration-none bg-transparent border-0 p-0"
            data-bs-toggle="collapse"
            data-bs-target="#assistant"
            aria-expanded="false"
            aria-controls="assistant"
          >
            <i className="fi fi-rr-brain-circuit"></i>
          </button>
        </div>

        <div className="col">
          <NavLink to="/courses" className={navLinkClass}>
            <i className="fi fi-rr-graduation-cap"></i>
          </NavLink>
        </div>

        <div className="col">
          <NavLink to="/account" className={navLinkClass}>
            <i className="fi fi-rr-settings"></i>
          </NavLink>
        </div>
      </div>
    </footer>
  );
}